<template>
  <div>
    <h1>{{ article.Title }}</h1>
    <p><i v-html="article.Abstract"></i></p>
    <p>
      <img :src="gravatarUrl" alt="User Avatar" class="avatar" style="vertical-align: middle; height: 1.3em;"/>
      <a :href="`/profile?username=${ article.AuthorName }`">
        u/{{ article.AuthorName }}
      </a>
    </p>
    <p>Published on: {{ article.CreatedAt }}</p>
    <p>CID: <a :href="`https://ipfs.io/ipfs/${article.CID}`">{{ article.CID }}</a></p>
    Download:
    <a :href="`${ config.apiBaseUrl }/articles/pdf/${article.CID}`" style="margin-right:10px;" download>
      Local PDF
    </a>
    <a :href="`${ config.apiBaseUrl }/articles/bibtex/${article.CID}`" style="margin-right:10px;" download>
      BibTeX
    </a>
    <a :href="`https://ipfs.io/ipfs/${article.StampCID}`" style="margin-right:10px;" download>
      PDF TimeStamp
    </a>
    <a :href="`https://ipfs.io/ipfs/${article.SigStampCID}`" style="margin-right:10px;" download>
      Signature TimeStamp
    </a>
    <a :href="`https://ipfs.io/ipfs/${article.SigCID}`" style="margin-right:10px;" download>
      GPG Signature
    </a>
    <button v-if="isAdmin" @click="deleteArticle(article.CID)" style="color: Red;">Delete</button>

    <br><br>
    <iframe
      :src="`https://mozilla.github.io/pdf.js/web/viewer.html?file=https://ipfs.io/ipfs/${article.CID}`"
      width="100%"
      height="600"
      style="border: none;"
    ></iframe>

    <br><br>
    <div v-html="sanitizedBodyContent"></div>

    <div id="commento"></div>

    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import config from '../config';
import md5 from 'md5';
import DOMPurify from "dompurify";

const article = ref({});
// const domain = new URL(window.location.origin).hostname;
const user = ref({});
const gravatarUrl = ref("");
const loading = ref(true);
const error = ref(null);
const route = useRoute();
const cid = ref(route.query.cid || "");
const token = sessionStorage.getItem("jwt");
const sanitizedBodyContent = ref("");

const fetchArticle = async () => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/articles/${ cid.value }`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    }); // Replace with your actual API endpoint
    if (!response.ok) {
      throw new Error('Failed to fetch articles');
    }
    const data = await response.json();
    article.value = data;
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

const fetchUser = async (article) => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/users/${ article.value.AuthorName }`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }
    const data = await response.json();
    user.value = data;
    gravatarUrl.value = `https://www.gravatar.com/avatar/${md5(user.value.email.trim().toLowerCase())}?s=200&d=identicon`;
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

const fetchAndExtractBody = async () => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/articles/html/${ cid.value }`); // Fetch the HTML 'file'
    if (!response.ok) throw new Error("Failed to fetch content");

    const htmlText = await response.text();
    const extractedBody = extractBody(htmlText);
    sanitizedBodyContent.value = DOMPurify.sanitize(extractedBody);
  } catch (error) {
    console.error("Error fetching HTML file:", error);
  }
};

const extractBody = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.innerHTML || "";
};

onMounted(async () => {
  loading.value = true;
  
  await fetchArticle();
  await fetchUser(article);
  await fetchAndExtractBody();

  const script = document.createElement('script')
  script.src = 'https://cdn.commento.io/js/commento.js'
  script.defer = true
  document.body.appendChild(script)
  
  loading.value = false;
});


</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
